import { useEffect } from 'react';

import { useFetcher } from '@remix-run/react';

export type PostInsights = {
  fetched: boolean;
  likes: PostLike[];
  comment_count: number;
};

export type PostLike = {
  created_at: string;
  id: string;
  liked: boolean;
  post_id: string;
  subscription_id: number;
  updated_at: string;
  user_id: string | null;
};

const getFilteredLikes = (likes: PostLike[]) => {
  if (!likes) return [];
  return likes.filter((like) => !!(like?.subscription_id || like?.user_id));
};

const usePostInsights = (postId: string): PostInsights => {
  // use regular fetcher because we want to revalidate after mutation (new like/comment)
  const fetcher = useFetcher<() => Promise<PostInsights[]>>();

  useEffect(() => {
    if (postId && fetcher.state === 'idle' && !fetcher.data) {
      fetcher.load(`/post_insights?post_id=${postId}`);
    }
  }, [postId, fetcher.data, fetcher.state]);

  return fetcher.data?.length
    ? {
        ...fetcher.data[0],
        likes: getFilteredLikes(fetcher.data[0].likes),
        fetched: true,
      }
    : {
        fetched: false,
        likes: [],
        comment_count: 0,
      };
};

export default usePostInsights;
